import { render, staticRenderFns } from "./StoryboardCreateCreative.vue?vue&type=template&id=6fa354c7&lang=pug"
import script from "./StoryboardCreateCreative.vue?vue&type=script&lang=js"
export * from "./StoryboardCreateCreative.vue?vue&type=script&lang=js"
import style0 from "./StoryboardCreateCreative.vue?vue&type=style&index=0&id=6fa354c7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports